"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const { colors, gridSize } = require("@atlaskit/theme");
const styled_components_1 = __importDefault(require("styled-components"));
class PropertyRow extends React.Component {
    render() {
        const { title, children } = this.props;
        return (React.createElement(PropertyRowContainer, null,
            React.createElement(PropertyLabel, null, title + ":"),
            React.createElement(PropertyValue, null, children)));
    }
}
exports.PropertyRow = PropertyRow;
exports.PropertiesContainer = styled_components_1.default.section `
  display: flex;
  flex-wrap: wrap;
  padding-bottom: ${gridSize() * 3}px;
  padding-top: ${gridSize() * 1.5}px;

  @media (min-width: 780px) {
    padding-top: ${gridSize() * 3}px;
  }
`;
const PropertyRowContainer = styled_components_1.default.div `
  box-sizing: border-box;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  padding: 0.4em 0;

  @media (min-width: 780px) {
    flex-direction: row;
  }
`;
const PropertyLabel = styled_components_1.default.div `
  color: ${colors.subtleText};
  flex-basis: 25%;
`;
const PropertyValue = styled_components_1.default.div `
  flex: 1 0 auto;
`;
